import store from "@/store";

class UserSyncWebSocketService {
	constructor(clientId) {
		this.clientId = clientId;
		this.listeners = [];
		this.socket = null;
		this.reconnectTimer = null;
		this.intentionalDisconnect = false;

		const { websocketUrl, websocketPort } = store.state.config;
		this.url = websocketUrl;
		this.port = websocketPort;
	}

	connect() {
		this.intentionalDisconnect = false;
		this.openSocket();
	}

	disconnect() {
		this.intentionalDisconnect = true;
		this.clearReconnectTimer();
		if (this.socket) {
			this.socket.close();
			this.socket = null;
		}
	}

	addMessageListener(listener) {
		this.listeners.push(listener);
	}

	removeMessageListener(listener) {
		this.listeners = this.listeners.filter((l) => l !== listener);
	}

	openSocket() {
		if (this.socket) {
			this.socket.close();
			this.socket = null;
		}

		this.emit("connecting");

		const socketUrl = `${this.url}:${this.port}/?uid=${this.clientId}`;
		this.socket = new WebSocket(socketUrl);

		this.socket.addEventListener("open", () => {
			this.emit("connected");
		});

		this.socket.addEventListener("message", (event) => {
			try {
				this.emit("message", JSON.parse(event.data));
			} catch (e) {
				console.warn("[UserSyncWebSocketService] Failed to parse message", e);
			}
		});

		this.socket.addEventListener("close", () => {
			this.emit("disconnected");
			if (!this.intentionalDisconnect) {
				this.scheduleReconnect();
			}
		});

		this.socket.addEventListener("error", (error) => {
			this.emit("error", error);
		});
	}

	scheduleReconnect() {
		this.clearReconnectTimer();
		this.reconnectTimer = setTimeout(() => {
			this.reconnectTimer = null;
			this.openSocket();
		}, 2000);
	}

	clearReconnectTimer() {
		if (this.reconnectTimer) {
			clearTimeout(this.reconnectTimer);
			this.reconnectTimer = null;
		}
	}

	emit(type, data) {
		this.listeners.forEach((listener) => {
			try {
				listener(type, data);
			} catch (e) {
				console.error("[UserSyncWebSocketService] Listener error", e);
			}
		});
	}
}

export default UserSyncWebSocketService;
